__webpack_require__.p = "/senze-3.0/";